import { createActions } from 'redux-actions';
import { LOADING } from '../actionTypes';

export default createActions({
  [LOADING]: (state) => {
    return state;
  }
});
